import React from "react";

const RightArrowSVG = ({ size }) => {
  return (
    <svg
      data-v-44a86371=""
      width={`${size}`}
      height={`${size}`}
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        data-v-44a86371=""
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0494 11.3366C13.3107 11.4875 13.4432 11.7499 13.4468 12.0139C13.4432 12.2779 13.3107 12.5403 13.0494 12.6912L1.36475 19.3933C1.36475 19.3933 0.338449 19.913 0.273475 21.0694C0.193093 22.5 1.7591 23.8646 3.34898 22.9191L18.2207 14.0749C19.0016 13.6105 19.3902 12.8114 19.3866 12.0139C19.3902 11.2164 19.0016 10.4173 18.2207 9.95287L3.34898 1.10874C1.7591 0.163246 0.193093 1.52784 0.273475 2.95842C0.338449 4.11478 1.36475 4.63446 1.36475 4.63446L13.0494 11.3366Z"
        fill="#B63A32"
      ></path>
    </svg>
  );
};

export default RightArrowSVG;
